import { useContext, useEffect } from 'react';
import portalTypeCheckers from '../../../types/portalTypeCheckers';
import CurrentUserContext from '../../../contexts/CurrentUserContext';
import { UIVersionContext } from './UIVersionProvider';
import { PortalsContext } from './PortalsProvider';

const NavigateToAdminPortalForV2Staff = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { isFleetOpsStaff } = useContext(CurrentUserContext);
  const { uiVersion } = useContext(UIVersionContext);
  const {
    isPortalsEnabled,
    selectedPortal,
    availablePortals,
    onPortalSelected,
  } = useContext(PortalsContext);

  /**
   * For FleetOps staff, select the admin portal by default
   * We need to sniff the pathname here as we have a dodgy flow where
   * this context provider has its state set via onPortalUrlSlugChanged
   * deeper in the render tree, from {@link PortalsSwitch}
   *
   * If this proves to be awkward to maintain going forward, the
   * selectedPortal state should be moved into its own context provider,
   * available after we know there is a :/portal/ in the url
   */
  useEffect(() => {
    if (!isFleetOpsStaff) {
      return;
    }

    if (!isPortalsEnabled) {
      return;
    }

    if (selectedPortal) {
      return;
    }

    if (uiVersion === 'v3') {
      return;
    }

    // We don't want to run this logic on a /:portal/ url
    if (window.location.pathname !== '/') {
      return;
    }

    const adminPortal = availablePortals.find(portalTypeCheckers.isAdminPortal);
    if (adminPortal) {
      onPortalSelected(adminPortal);
    }
  }, [
    availablePortals,
    isFleetOpsStaff,
    isPortalsEnabled,
    onPortalSelected,
    selectedPortal,
    uiVersion,
  ]);

  return <>{children}</>;
};

export default NavigateToAdminPortalForV2Staff;
